import React, { useEffect, useState } from "react"
import { Button, componentStyles } from "@mallardbay/lib-react-components"

interface Props {
    readonly shouldAnimate: boolean
    readonly label: string
    readonly isDisabled: boolean
    readonly onClick: () => void
    readonly isLoading: boolean
    readonly isSmall?: boolean
}

export default function AnimatedButton({
    shouldAnimate,
    label,
    isDisabled,
    onClick,
    isLoading,
    isSmall,
}: Props) {
    const [isAnimating, setIsAnimating] = useState(false)
    const styles = useStyles({ isSmall, isAnimating })

    useButtonAnimation({
        shouldAnimate,
        setIsAnimating,
    })

    return (
        <Button
            style={styles.button}
            isDisabled={isDisabled}
            onClick={onClick}
            isLoading={isLoading}
            gradientEnabled
        >
            {label}
        </Button>
    )
}

function useButtonAnimation({
    shouldAnimate,
    setIsAnimating,
}: {
    readonly shouldAnimate: boolean
    readonly setIsAnimating: (isAnimating: boolean) => void
}) {
    useEffect(() => {
        if (shouldAnimate) {
            setIsAnimating(true)
            const timeout = setTimeout(() => setIsAnimating(false), 300)
            return () => clearTimeout(timeout)
        }

        return setIsAnimating(false)
    }, [shouldAnimate])
}

function useStyles({
    isSmall,
    isAnimating,
}: {
    readonly isSmall?: boolean
    readonly isAnimating: boolean
}) {
    return componentStyles({
        button: {
            transform: isAnimating ? "scale(1.1)" : "scale(1)",
            transition: "transform 0.3s ease-in-out",
            width: isSmall ? "50%" : "100%",
            marginTop: "20px",
        },
    })
}
